import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import { useToast } from "../../contexts/ToastContext";


import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function CustomerGroupsViewModel(logout) {
  const { showSuccess } = useToast();
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [customerGroups, setCustomerGroups] = useState({
    data: [],
  });

  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getCustomerGroups = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`customerGroups`, payload);
    setLoading(false);
    if (callResult.success) {
      setCustomerGroups(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch customer groups");
    }
  };

  return {
    emptyModal,
    setEmptyModelOpen,
    getCustomerGroups,
    loading,
    customerGroups,
    setSlideOver,
    slideOver,
  };
}
